<template>
  <div id="app">
    <router-view />

    <component :is="currentNightAuditComponent"></component>
    <ShiftChoose></ShiftChoose>
    <GlobalTip></GlobalTip>
    <PrintLoading v-show="printLoading"></PrintLoading>
    <div id="divDevicePlugins" style="width: 0px; height: 0px;">
      <object id="IE_IdReaderCtl" classid="CLSID:29281FF6-F680-4901-8CB0-1A25A09EA8FB"
        style="width: 0px; height: 0px;"></object>
      <embed id="FF_IdReaderCtl" type="application/x-idreader" style="width: 0px; height: 0px;" />
      <!-- <object id="IE_DoorLockCtl_4" classid="CLSID:C934ADA0-D568-4E72-9F53-7E01E8B25134" style="width: 0px;height: 0px;"></object>
      <embed id="FF_DoorLockCtl_4" type="application/x-pulandelock" style="width: 0px;height: 0px;"/> -->
      <object id="IE_DoorLockCtl_2" classid="CLSID:C934ADA0-D568-4E72-9F53-7E01E8B25134"
        style="width: 0px; height: 0px;"></object>
      <embed id="FF_DoorLockCtl_2" type="application/x-tongchuanglock" style="width: 0px; height: 0px;" />

      <object id="IE_DoorLockCtl_1" classid="CLSID:C934ADA0-D568-4E72-9F53-7E01E8B25134"
        style="width: 0px; height: 0px;"></object>
      <embed id="FF_DoorLockCtl_1" type="application/x-locstarlock" style="width: 0px; height: 0px;" />

      <object id="IE_DoorLockCtl_0" classid="CLSID:C3DB5B0E-E9C1-4707-B139-7F34BADF438F"
        style="width: 0px; height: 0px;"></object>
      <embed id="FF_DoorLockCtl_0" type="application/x-adellock" style="width: 0px; height: 0px;" />

      <object id="IE_DoorLockCtl_3" classid="CLSID:083D95FD-ABEA-4850-B086-06E6CBE592B3"
        style="width: 0px; height: 0px;"></object>
      <embed id="FF_DoorLockCtl_3" type="application/x-bidalock" style="width: 0px; height: 0px;" />

      <object id="IE_DoorLockCtl_8" classid="CLSID:BB7C8666-9C9B-49C0-AC8A-90AAE7DFBCE8"
        style="width: 0px; height: 0px;"></object>
      <embed id="FF_DoorLockCtl_8" type="application/x-tianyuelock" style="width: 0px; height: 0px;" />

      <object id="IE_DoorLockCtl_5" classid="CLSID:5F93A8D1-EE76-4570-A4E2-30FC8722B552"
        style="width: 0px; height: 0px;"></object>
      <embed id="FF_DoorLockCtl_5" type="application/x-bangweilock" style="width: 0px; height: 0px;" />

      <object id="IE_DoorLockCtl_10" classid="CLSID:5249A986-FE5C-456B-A6F7-3E6200963A11"
        style="width: 0px; height: 0px;"></object>
      <embed id="FF_DoorLockCtl_10" type="application/x-adel-1800" style="width: 0px; height: 0px;" />

      <object id="IE_DoorLockCtl_12" classid="CLSID:C934ADA0-D568-4E72-9F53-7E01E8B25134"
        style="width: 0px; height: 0px;"></object>
      <embed id="FF_DoorLockCtl_12" type="application/x-meituanlock" style="width: 0px; height: 0px;" />
    </div>
  </div>
</template>

<script>
import { initGlobalSocket } from '@/utils/index';
import initStorageListener from '@/utils/shareStorage';
// import config from './config'
export default {
  name: 'App',
  computed: {
    currentNightAuditComponent() {
      return this.$store.getters.isNightAuditGrayEnv ? 'NightAuditGrayEnv' : 'NightAudit';
    },
    printLoading() {
      return this.$store.getters.printLoading;
    },
  },
  watch: {
    '$store.getters.hotelCode'(value) {
      if (value) {
        initGlobalSocket();
      }
    },
    $route() {
      var location = window.location; // 路由变化
      var contentUrl = location.pathname; // 自定义当前url，可带上路由以此区分每个页面
      var refererUrl = '/';
      this.$uweb.trackPageview(contentUrl, refererUrl);
    },
  },
  mounted() {
    initStorageListener();
  },
};
</script>
